import { createElement } from 'react';
import type {
  GridCellTemplateContext,
  GridCellTemplateRegistry,
  GridCellTemplateRenderer,
  GridCellTemplateRenderResult,
} from './types';
import {
  customizeDurationDisplay,
  decorateBooleanBar,
  decorateTimeProgressBar,
} from './trackedDayStatisticTemplates';
import { CopyExternalFeedbackLinkCell } from '../../employee-review/components/CopyExternalFeedbackLinkCell';
import { EmployeeReviewStatusCell } from '../../employee-review/components/EmployeeReviewStatusCell';
import { BankTransactionIncomeExpenseTypeCell } from '../../bank-transactions/components/BankTransactionIncomeExpenseTypeCell';
import { formatCellColorConditionally } from './conditionalColorTemplate';
import { FinanceEmailHistoryLinkCell } from './FinanceEmailHistoryLinkCell';

const gridCellTemplateRegistry: GridCellTemplateRegistry = new Map([
  ['decorateTimeProgressBar', decorateTimeProgressBar],
  ['decorateBooleanBar', decorateBooleanBar],
  ['customizeDurationDisplay', customizeDurationDisplay],
  ['formatCellColorConditionally', formatCellColorConditionally],
  [
    'copyexternalfeedbacklink',
    ({ row, parentId }) => ({
      content: createElement(CopyExternalFeedbackLinkCell, { row: row ?? {}, reviewId: parentId }),
    }),
  ],
  [
    'employeereviewstatus',
    ({ value }) => ({
      content: createElement(EmployeeReviewStatusCell, { value }),
    }),
  ],
  [
    'banktransactionincomeexpensetype',
    ({ value }) => ({
      content: createElement(BankTransactionIncomeExpenseTypeCell, { value }),
    }),
  ],
  [
    'financeemailhistorylink',
    ({ value, displayValue, row, rawParams }) => ({
      content: createElement(FinanceEmailHistoryLinkCell, {
        dateValue: value,
        displayValue,
        row,
        rawParams,
      }),
    }),
  ],
]);

export const resolveGridCellTemplate = (
  templateName: string | null | undefined,
  registry: GridCellTemplateRegistry = gridCellTemplateRegistry
): GridCellTemplateRenderer | null => {
  if (!templateName) return null;
  return registry.get(templateName) ?? registry.get(templateName.toLowerCase()) ?? null;
};

export const renderGridCellTemplate = (
  templateName: string | null | undefined,
  context: GridCellTemplateContext,
  registry: GridCellTemplateRegistry = gridCellTemplateRegistry
): GridCellTemplateRenderResult | null => {
  const renderer = resolveGridCellTemplate(templateName, registry);
  if (!renderer) return null;

  try {
    return renderer(context);
  } catch {
    return null;
  }
};
